<template>
    <div>
        <div class="col-md-3 col-xs-12">
            <va-small-box
              class="info-box box-green"
              icon="ion-bag "
              :title=message[1].totalDisbursment
              description="Total Disbursement Amount"
              @more-click="clickToTotalDisbursment"
              moreText="More info">
            </va-small-box>
        </div>
        <div class="col-md-3 col-xs-12">
            <va-small-box
              class="info-box box-red"
              icon="ion-bag "
              :title=message[2].totalOutstanding
              description="Total Outstanding Amount"
              @more-click="clickToTotalOutstanding"
              moreText="More info">
            </va-small-box>
        </div>
    </div>
</template>
<script>
import VASmallBox from '../widgets/VASmallBox.vue'
export default {
  props: ['message'],
  data () {
    return {
      totalAmt: 0,
      totalReceivedAmt: 0,
      totalOutstanding: 0,
      totalDisbursement: 0
    }
  },
  methods: {
    clickToTotalDisbursment () {
      this.$router.push({name: 'loanSummary'})
    },
    clickToTotalOutstanding () {
      this.$router.push({name: 'emiCollection'})
    }
  },
  components: {
    'va-small-box': VASmallBox
  }
}
</script>
<style>
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .blueColor {
    color: rgb(12, 156, 55);
  }
  .box-red {
    background-color:#ec1c22;
    color: #fff;
  }
  .box-green {
    background-color: #0e8c0e;
    color: #fff;
  }
  /* .iconColor {
    color: rgb(12, 156, 55);
  } */
  /* .small-box > .small-box-footer {
  background: rgb(12, 156, 55);
} */
</style>



// WEBPACK FOOTER //
// totaloutstanding.vue?c80fed1e